/**
 * 格式化用户答案对象为表单可用数据
 * @param answerList 用户答案列表
 * @returns [答案对象， 是否已答题]
 */
export var formatAnswerObj = function formatAnswerObj(answerList) {
  var obj = {};
  var hadAnswer = false;
  answerList.forEach(function (item) {
    var answer;
    try {
      answer = JSON.parse(item.answer);
    } catch (error) {
      answer = item.answer;
    }
    if (item.answerFlag) hadAnswer = true;
    // 若未填则显示 ‘暂未答案’   --> 若首题未非必填且未答题显示将有异常但场景很少
    obj[item.question.name] = item.answerFlag || hadAnswer ? answer : undefined;
  });
  return [obj, hadAnswer];
};

/**
 * 获取问题验证roles
 * @param item 问题对象
 */
export var getVerifyRoles = function getVerifyRoles(item) {
  var roles = [{
    required: item.requiredFlag,
    message: '该选项为必填'
  }];
  if (item.bizTypeName === '手机号码') {
    roles.push({
      pattern: new RegExp(/^(1[3-9][0-9])[0-9]{8}$/),
      message: '请输入正确的手机号'
    });
  }
  if (item.bizTypeName === '邮箱') {
    roles.push({
      pattern: new RegExp(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/),
      message: '请输入正确的邮箱'
    });
  }
  if (item.bizTypeName === '微信号码') {
    roles.push({
      pattern: new RegExp(/^[a-zA-Z]([-_a-zA-Z0-9]{5,20})$/),
      message: '请输入正确的微信号码'
    });
  }
  if (item.bizTypeName === '国际号') {
    roles.push({
      pattern: new RegExp(/^(86)1[3-9]\d{9}$|^(?!86)\d{1,3}[1-9]\d{1,14}$/),
      message: '请输入正确的手机号码'
    });
  }
  return roles;
};